import { usePlatform } from "@platform//PlatformContext";
import { useFetchUserCircles } from "@platform/hooks/useFetchUserCircles";
import { Settings } from "../../settings/components/Settings/Settings";
import { useDashboard } from "../DashboardContext";

export function DashboardSettingsPage() {
  const { user } = usePlatform();

  const { program, organization } = useDashboard();

  // Load user circles data for chat visibility logic
  useFetchUserCircles();

  return <Settings program={program} user={user} organization={organization} />;
}

export default DashboardSettingsPage;
